/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M6.
 * Account-scoped client for the Eva documents (knowledge sources) API
 * (/api/v1/accounts/:account_id/eva/documents).
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaDocumentsAPI extends ApiClient {
  constructor() {
    super('eva/documents', { accountScoped: true });
  }

  getByAssistant(assistantId) {
    return axios.get(this.url, { params: { eva_assistant_id: assistantId } });
  }

  // Re-chunk an available document into fresh responses.
  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new EvaDocumentsAPI();
